<div class="time-range-buttons timeline-content">
    <span class="font-small timeline-title">
        <mat-icon mat-icon-button svgIcon="timeline-chunk"></mat-icon>
    </span>
    <button class="toggle-arrow font-small" (click)="showTimeRangeButtons = !showTimeRangeButtons">
        <mat-icon>{{ showTimeRangeButtons ? 'chevron_left' : 'chevron_right' }}</mat-icon>
    </button>

    <div class="time-range-buttons" [ngClass]="{'time-range-buttons-hidden': !showTimeRangeButtons}">
        <button *ngFor="let label of timeLineChunkKeys" [ngClass]="{ selected: isSelected(label) }"
            (click)="setTimeline(label)">
            {{ label }}
        </button>
        <button class="toggle-arrow font-small" (click)="handleTimeLineRangeRefresh()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
</div>